import { useEffect } from "react";
import styles from "./Dashboard.module.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import ChatSection from "../../components/ChatPanel/ChatSection";
import CreateCommunityPage from "../Community/CreateCommunityPage";
import CreateChannelPage from "../Channel/CreateChannelPage";
import AllCommunities from "../Community/AllCommunityPage";
import AllChannels from "../Channel/AllChannelPage";
import CreateLiveSessionPage from "../LiveSession/CreateLiveSessionPage";
import AllLiveSessions from "../LiveSession/AllLiveSessionPage";
import AppBar from "../../components/AppBar/AppBar";
import useAuthStore from "../../store/authStore";
import useDashboardStore from "../../store/dashboardStore";
import chatStore from "../../store/chatStore";
import AdminMenuPanel from "../../components/CommunityDetails/AdminMenuPanel";
import TraderMenuPanel from "../../components/CommunityDetails/TraderMenuPanel";
import CommunityMenuPanel from "../../components/CommunityDetails/CommunityMenuPanel";
import ZoomMeetingCard from "../../components/ZoomMeeting/ZoomMeetingCard";
import UpcomingLiveSessions from "../../components/UpcomingLiveSession/UpcomingLiveSession";
import UsersPage from "../Users/UsersPage";
import MyProfile from "../../components/MyProfile/MyProfile";
import MyMembership from "../../components/MyProfile/MySubsription";
import Us30Page from "../US30/Us30Page";
import { ENDPOINTS } from "../../utils/endpoints";
import api from "../../services/api";
import { playMessageSound } from "../../utils/playsound";
import { toast } from "react-toastify";

import AllHomeSections from "../Home/AllHomeSections.jsx";
import CreateHomeSection from "../Home/CreateHomeSection.jsx";

const Dashboard = () => {
  const { user, socket } = useAuthStore();
  const {
    setLiveUserCounts,
    setUnreadChatCounts,
    setNewMessageRecieved,
    setNewMessageReactionRecieved,
    setNewChatPermissionRecieved,
    setNewChatNotificationRecieved,
    notificationPermissionList,
    setNotificationPermissionList,
  } = chatStore();
  const {
    isIconChoosed,
    isCommunityChoosed,
    isUS30Choosed,
    isCreateCommunityScreen,
    isAllCommunityScreen,
    isCreateChannelScreen,
    isAllChannelScreen,
    isCreateLiveSessionScreen,
    isAllLiveSessionScreen,
    isAllHomeSectionScreen,
    isCreateHomeSectionScreen,
    isChatScreen,
    isZoomMeetingScreen,
    isUpcomingLiveSessionScreen,
    isUsersScreen,
    setTraders,
    setUsers,
    isMyProfileScreen,
    isMyMembershipScreen,
    setUserJoinedChannels,
    selectedChannel,
    setIsUS30Choosed,
    setIsMyProfileScreen,
    setIsMyMembershipScreen,
    setIsIconChoosed,
    setIsAllCommunityScreen,
    setIsCreateCommunityScreen,
    setIsAllChannelScreen,
    setIsCreateChannelScreen,
    setIsAllLiveSessionScreen,
    setIsCreateLiveSessionScreen,
    setIsAllHomeSectionScreen,
    setIsCreateHomeSectionScreen,
    setIsUsersScreen,
  } = useDashboardStore();

  useEffect(() => {
    // user.roles = ['administrator'];
    // user.roles = ['trader'];

    const INACTIVITY_LIMIT = 30 * 60 * 1000;

    // Save last activity timestamp whenever user does something
    const updateLastActivity = () => {
      localStorage.setItem("lastActivity", Date.now().toString());
    };

    // Track activity events
    window.addEventListener("mousemove", updateLastActivity);
    window.addEventListener("keydown", updateLastActivity);
    window.addEventListener("click", updateLastActivity);

    const lastActivity = localStorage.getItem("lastActivity");
    const now = Date.now();

    // If user inactive for more than 30 mins → reset to US30
    if (lastActivity && now - parseInt(lastActivity, 10) > INACTIVITY_LIMIT) {
      localStorage.setItem("lastScreen", "US30");
    }

    // API calls
    const fetchTraders = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_ALL_TRADERS_SIMPLE);
        if (data.success) {
          setTraders(data.traders);
        }
      } catch (err) {
        console.error("Failed to fetch traders", err);
      }
    };

    const fetchUsers = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_ALL_USERS_SIMPLE);
        if (data.success) {
          setUsers(data.users);
        }
      } catch (err) {
        console.error("Failed to fetch users", err);
      }
    };

    const getAllJoinedChannels = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_JOINED_CHANNEL(user.id));
        if (data.success) {
          const channelsJoined = data.channels || [];
          setUserJoinedChannels(channelsJoined);

          // Join the channel chat rooms
          if (!socket) return;
          socket.emit("join-channels", channelsJoined, user.id);
        }
      } catch (err) {
        console.error("Error joining channels:", err);
      }
    };

    const fetchChatsUnreadCounts = async () => {
      try {
        const res = await api.get(ENDPOINTS.GET_UNREAD_CHAT_COUNTS(user.id));
        if (res.data.success) {
          setUnreadChatCounts(res.data.unreadCounts);
        }
      } catch (err) {
        console.error("Failed to fetch unread counts", err);
      }
    };

    const fetchChatsNotificationPermission = async () => {
      try {
        const res = await api.post(ENDPOINTS.GET_CHAT_NOTIFICATION, {
          userId: user.id,
        });
        if (res.data.success) {
          setNotificationPermissionList(res.data.notifications);
        }
      } catch (err) {
        console.error("Failed to fetch chat notification", err);
      }
    };

    getAllJoinedChannels();
    fetchChatsUnreadCounts();
    fetchChatsNotificationPermission();
    fetchTraders();
    fetchUsers();

    //on refresh land on same page as previously selected
    const timer = setTimeout(() => {
      const lastScreen = localStorage.getItem("lastScreen");
      if (lastScreen === "US30") {
        setIsUS30Choosed();
      } else if (lastScreen === "MyProfile") {
        setIsMyProfileScreen();
      } else if (lastScreen === "MySubscription") {
        setIsMyMembershipScreen();
      } else if (
        lastScreen === "ChatScreen" ||
        lastScreen === "UpcomingLiveSessionScreen"
      ) {
        //Handled in Sidebar line 46
      } else if (lastScreen === "AllCommunityScreen") {
        setIsIconChoosed();
        setIsAllCommunityScreen();
      } else if (lastScreen === "CreateCommunityScreen") {
        setIsIconChoosed();
        setIsCreateCommunityScreen();
      } else if (lastScreen === "AllChannelScreen") {
        setIsIconChoosed();
        setIsAllChannelScreen();
      } else if (lastScreen === "CreateChannelScreen") {
        setIsIconChoosed();
        setIsCreateChannelScreen();
      } else if (lastScreen === "AllLiveSessionScreen") {
        setIsIconChoosed();
        setIsAllLiveSessionScreen();
      } else if (lastScreen === "CreateLiveSessionScreen") {
        setIsIconChoosed();
        setIsCreateLiveSessionScreen();
      } else if (lastScreen === "AllHomeSectionScreen") {
        // Added for Home Sections
        setIsIconChoosed();
        setIsAllHomeSectionScreen();
      } else if (lastScreen === "CreateHomeSectionScreen") {
        // Added for Home Sections
        setIsIconChoosed();
        setIsCreateHomeSectionScreen();
      } else if (lastScreen === "UsersScreen") {
        setIsIconChoosed();
        setIsUsersScreen();
      } else {
        setIsUS30Choosed();
      }
    }, 500); // wait 0.5 sec

    return () => {
      // cleanup event listeners
      window.removeEventListener("mousemove", updateLastActivity);
      window.removeEventListener("keydown", updateLastActivity);
      window.removeEventListener("click", updateLastActivity);
      clearTimeout(timer);
    };
  }, [
    setTraders,
    setUsers,
    socket,
    setUnreadChatCounts,
    setNotificationPermissionList,
    setUserJoinedChannels,
  ]);

  useEffect(() => {
    if (!socket) return;

    // Remove any previous listener to avoid duplicates
    socket.off("new-message");
    socket.off("message-reaction");
    socket.off("chat-permission-change");
    socket.off("chat-notification-change");
    socket.off("channel-user-count");
    socket.off("liveSessionReminder");

    socket.on("new-message", (data) => {
      setNewMessageRecieved(data);

      if (data.userId !== user.id) {
        // Check if user is currently viewing this channel
        const isViewingThisChannel =
          !document.hidden &&
          localStorage.getItem("lastScreen") === "ChatScreen" &&
          selectedChannel?.id === data.channelId;

        // Only increment unread count if NOT viewing this channel
        if (!isViewingThisChannel) {
          setUnreadChatCounts((prev) => ({
            ...prev,
            [data.channelId]: (prev[data.channelId] || 0) + 1,
          }));
        }

        //Play sound only if not viewing this channel
        if (!isViewingThisChannel) {
          let isMuted =
            notificationPermissionList.find(
              (e) => e.channel_id === data.channelId
            )?.enable_notification === 0;
          if (!isMuted) {
            playMessageSound();
          }
        }
      }
    });

    socket.on("message-reaction", (data) => {
      setNewMessageReactionRecieved(data);
    });

    socket.on("chat-permission-change", (data) => {
      setNewChatPermissionRecieved(data);
    });

    socket.on("chat-notification-change", (data) => {
      setNewChatNotificationRecieved(data);
    });

    socket.on("channel-user-count", (data) => {
      setLiveUserCounts(data.channelUsers);
    });

    socket.on("liveSessionReminder", (data) => {
      if (!data || !data.title) return;

      let message;
      if (data.type === "10_minutes") {
        message = `${data.title} is starting in 10 minutes!`;
      } else if (data.type === "starting_now") {
        message = `${data.title} is starting now!`;
      } else {
        // Fallback for backward compatibility
        message = `${data.title} is starting soon`;
      }

      playMessageSound();
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    });

    return () => {
      socket.off("new-message");
      socket.off("message-reaction");
      socket.off("chat-permission-change");
      socket.off("chat-notification-change");
      socket.off("channel-user-count");
      socket.off("liveSessionReminder");
    };
  }, [
    socket,
    setUnreadChatCounts,
    selectedChannel?.id,
    notificationPermissionList,
    setLiveUserCounts,
    setNewMessageRecieved,
    setNewMessageReactionRecieved,
    setNewChatPermissionRecieved,
    setNewChatNotificationRecieved,
    user.id,
  ]);

  // Auto-join all accessible channels globally
  useEffect(() => {
    const autoJoinAllAccessibleChannels = async () => {
      if (!user || !socket) return;

      try {
        // First, get the current joined channels list
        let currentJoinedChannels = [];
        try {
          const { data } = await api.get(ENDPOINTS.GET_JOINED_CHANNEL(user.id));
          if (data.success) {
            currentJoinedChannels = data.channels || [];
          }
        } catch (err) {
          console.error("Failed to fetch joined channels:", err);
          return;
        }

        // Get all channels
        const { data: channelsData } = await api.get(
          ENDPOINTS.GET_ALL_CHANNELS
        );
        const allChannels = channelsData.channels || [];

        if (allChannels.length === 0) return;

        const role = user?.roles?.[0];

        for (const channel of allChannels) {
          try {
            // Skip if already joined
            const isAlreadyJoined = currentJoinedChannels.some(
              (joined) => joined.channel_id === channel.id
            );

            if (isAlreadyJoined) {
              console.log(`Already joined channel: ${channel.name}`);
              continue; // Skip to next channel
            }

            // Fetch channel data if needed
            let channelData = {};
            if (channel.is_paid === 1 || role === "trader") {
              const { data } = await api.get(
                ENDPOINTS.GET_CHANNEL_BY_ID(channel.id)
              );
              channelData = data.channel || {};
            }

            let accessible = false;

            // Paid channel → check memberships
            if (channel.is_paid === 1) {
              const membershipsAllowed = channelData.membership_ids || [];

              let userMembershipIds = [];
              if (Array.isArray(user?.membership_ids)) {
                userMembershipIds = user.membership_ids.map(Number);
              } else if (typeof user?.membership_ids === "string") {
                try {
                  userMembershipIds = JSON.parse(user.membership_ids).map(
                    Number
                  );
                } catch {
                  userMembershipIds = [];
                }
              }

              accessible = membershipsAllowed.some((id) =>
                userMembershipIds.includes(id)
              );

              const tradersAllowed = channelData.trader_ids || [];
              if (tradersAllowed.includes(user.id)) {
                accessible = true;
              }
            } else {
              accessible = true;
            }

            // Trader role check
            if (role === "trader") {
              const tradersAllowed = channelData.trader_ids || [];
              if (tradersAllowed.includes(user.id)) {
                accessible = true;
              }
            }

            // Admin always accessible
            if (role === "administrator") {
              accessible = true;
            }

            // Auto-join if accessible
            if (accessible) {
              await api.post(ENDPOINTS.JOIN_CHANNEL_CHAT(channel.id), {
                userId: user.id,
              });
              console.log(`✅ Auto-joined channel: ${channel.name}`);
            }
          } catch (err) {
            console.error(`Failed to auto-join channel ${channel.id}:`, err);
          }
        }

        // Refresh joined channels list after auto-joining
        const { data } = await api.get(ENDPOINTS.GET_JOINED_CHANNEL(user.id));
        if (data.success) {
          const channelsJoined = data.channels || [];
          setUserJoinedChannels(channelsJoined);

          if (socket) {
            socket.emit("join-channels", channelsJoined, user.id);
          }
          console.log("✅ Joined channels list updated");
        }
      } catch (err) {
        console.error("Failed to auto-join channels:", err);
      }
    };

    // Only run once when component mounts and user is authenticated
    if (user?.id && socket) {
      autoJoinAllAccessibleChannels();
    }
  }, [user?.id, socket]); // Only run when user logs in

  const enableChatSection =
    isMyProfileScreen ||
    isMyMembershipScreen ||
    isUS30Choosed ||
    isCreateCommunityScreen ||
    isAllCommunityScreen ||
    isCreateChannelScreen ||
    isAllChannelScreen ||
    isCreateLiveSessionScreen ||
    isAllLiveSessionScreen ||
    isAllHomeSectionScreen ||
    isCreateHomeSectionScreen ||
    isUsersScreen ||
    isChatScreen ||
    isZoomMeetingScreen ||
    isUpcomingLiveSessionScreen;

  return (
    <div className={styles.dashboard}>
      <AppBar user={user} />

      <div className={styles.layout}>
        <div className={styles.sidebar}>
          <Sidebar />
        </div>

        {!isUS30Choosed &&
          (() => {
            const commonClass = `${styles.community} ${
              enableChatSection && window.innerWidth <= 768
                ? styles.hideOnMobile
                : ""
            }`;

            let Panel = null;
            if (isIconChoosed) {
              Panel =
                user?.roles[0] === "administrator" ? (
                  <AdminMenuPanel />
                ) : (
                  <TraderMenuPanel />
                );
            } else if (isCommunityChoosed) {
              Panel = <CommunityMenuPanel />;
            }

            return Panel ? <div className={commonClass}>{Panel}</div> : null;
          })()}

        <div
          className={`${styles.chat} ${
            !enableChatSection && window.innerWidth <= 768
              ? styles.hideOnMobile
              : ""
          }`}
        >
          {isMyProfileScreen ? (
            <MyProfile />
          ) : isMyMembershipScreen ? (
            <MyMembership />
          ) : isUS30Choosed ? (
            <Us30Page />
          ) : isCreateCommunityScreen ? (
            <CreateCommunityPage />
          ) : isAllCommunityScreen ? (
            <AllCommunities />
          ) : isCreateChannelScreen ? (
            <CreateChannelPage />
          ) : isAllChannelScreen ? (
            <AllChannels />
          ) : isCreateLiveSessionScreen ? (
            <CreateLiveSessionPage />
          ) : isAllLiveSessionScreen ? (
            <AllLiveSessions />
          ) : isAllHomeSectionScreen ? (
            <AllHomeSections />
          ) : isCreateHomeSectionScreen ? (
            <CreateHomeSection />
          ) : isUsersScreen ? (
            <UsersPage />
          ) : isChatScreen ? (
            <ChatSection />
          ) : isZoomMeetingScreen ? (
            <ZoomMeetingCard />
          ) : isUpcomingLiveSessionScreen ? (
            <UpcomingLiveSessions />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
